<template>
  <div class="projects-index">
    <page-header :title="pageTitle">
      <template #action>
        <v-btn
          :to="{ name: 'project-create' }"
          link
          color="blue"
          class="projects-index__btn"
        >
          CREATE PROJECT
        </v-btn>
      </template>
    </page-header>

    <div class="projects-index__list">
      <template v-if="isProjectsListNotEmpty">
        <ProjectCard
          v-for="project in projectsList"
          :key="project.id"
          :projectData="project"
          @delete="deleteSingleProject"
        />

        <v-pagination
          v-if="pagination.pageCount > 1"
          v-model="paginationPage"
          class="mb-4"
          color="blue"
          :disabled="isDataLoading"
          :length="pagination.pageCount"
        ></v-pagination>
      </template>

      <template v-else>
        <div class="projects-index__empty">
          <img class="projects-index__empty-img" src="@/assets/img/empty-projects.svg" />
          <h3 class="projects-index__empty-title">Create your first project</h3>
          <p class="projects-index__empty-description">
            Thank you for using the application.<br>
            Add your first project and we will match developers for you
          </p>
          <v-btn
            color="blue"
            class="white--text"
            large
            min-width="256"
            @click="goToCreatePage"
          >
            CREATE PROJECT
          </v-btn>
        </div>
      </template>
    </div>

    <ConfirmDialog ref="confirmDialog" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PageHeader from '@/components/PageHeader.vue';
import ProjectCard from '@/components/Projects/Index/ProjectCard.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';

export default {
  metaInfo: {
    title: 'Projects',
  },

  components: {
    PageHeader,
    ProjectCard,
    ConfirmDialog,
  },

  data() {
    return {
      pageTitle: 'Projects',
    };
  },

  computed: {
    ...mapState('projects', [
      'projectsList',
      'pagination',
      'isDataLoading',
    ]),

    isProjectsListNotEmpty() {
      return this.projectsList.length > 0;
    },

    paginationPage: {
      get() {
        return this.pagination.page;
      },
      set(val) {
        this.changePage(val);
      },
    },
  },

  created() {
    this.fetchProjects();
  },

  methods: {
    ...mapActions('projects', [
      'fetchProjects',
      'deleteProject',
      'changePage',
    ]),

    deleteSingleProject(id) {
      this.$refs.confirmDialog
        .open({
          message: 'Are you sure you want to delete project?',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        })
        .then((confirm) => {
          if (confirm) {
            this.deleteProject(id)
              .then(() => {
                this.fetchProjects();
              });
          }
        });
    },

    goToCreatePage() {
      this.$router.push({ name: 'project-create' });
    },
  },
};
</script>

<style lang="scss" scoped>
.projects-index {
  &__btn {
    font-weight: 400;
    color: white;
  }
  &__list {
    margin-top: 32px;
  }

  &__empty {
    min-height: calc(100vh - 180px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    @include tablet {
      min-height: calc(100vh - 150px);
    }
  }
  &__empty-img {
    margin-bottom: 24px;
    max-width: 100%;
  }
  &__empty-title {
    font-size: 18px;
    line-height: 36px;
  }
  &__empty-description {
    color: #B9BEC4;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 24px;
  }
}
</style>
